// extracted by mini-css-extract-plugin
module.exports = {"content":"AccountChannelDelete_content__DL0gF"};